import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'

import { Nav, Tab, Tabs } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';

import TopHeaderBusiness from '../../../../../components/general/TopHeaderBusiness';

import BusinessGroupList from './BusinessGroupList';
import BusinessGroupMis from './businessGroupMis/BusinessGroupMis';



export default function BusinessGroupListMain() {
    const { palette, typography, breakpoints, spacing } = useTheme()
    const matches = useMediaQuery(breakpoints.up('lg'));
 

    const [key, setKey] = useState('Group List');
    const location = useLocation();
    function handleClick(event) {
        event.preventDefault();
        console.info('You clicked a breadcrumb.');
    }

    return (
        <Box>
            <CssBaseline />
            <TopHeaderBusiness/>
            <Box mt={spacing(1)}>
                <Stack direction={'row'} sx={{ position: 'absolute', columnGap: spacing(1) }} role="presentation" onClick={handleClick}>
                    <NavLink style={{ textDecoration: "none", color: palette.primary.main }}>
                       Business Dashboard
                    </NavLink>
                    <NavLink style={{ textDecoration: "none", color: palette.primary.main }}>
                        {/* {location.pathname} */}
                    </NavLink>
                </Stack>
                <Tabs
                    style={{ justifyContent: "flex-end" }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >
                    
                    <Tab eventKey="Group List" title="Group List">
                       
                       <BusinessGroupList/>
                       
                    </Tab>

                    <Tab eventKey="Group MIS" title="Group MIS">
                       
                        <BusinessGroupMis/>
                    </Tab>

                    
                </Tabs>
            </Box>
        </Box>

    )
}
